import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
    api_url = `${protocol}//${hostname}/api`
}

const getAccessibilitiesRequested = () => ({
    type: types.GET_ACCESSIBILITIES_REQUESTED,
    payload: null
})

const getAccessibilitiesFulfilled = (data: any) => ({
    type: types.GET_ACCESSIBILITIES_FULFILLED,
    payload: data
})

const getAccessibilitiesRejected = (error: any) => ({
    type: types.GET_ACCESSIBILITIES_REJECTED,
    payload: error
})

export const getAccessibilities = (token: string) => {
    return (dispatch: any) => {
        dispatch(getAccessibilitiesRequested())
        request
            .get(`${api_url}/accessibility`)
            .set('Accept', 'application/json')
            .set('access-token', token)
            .then((response) => {
                dispatch(getAccessibilitiesFulfilled(response.body))
            })
            .catch((error) => {
                dispatch(getAccessibilitiesRejected(error))
            })
    }
}